<template>
  <section class="media-section-container">
    <div class="content-wrapper">
      <div class="text">
        <p>Ahol találkozhattál velünk:</p>
      </div>
      <div class="icon-wrapper">
        <a href="https://bit.ly/2WUJc1Y" target="_blank"><img src="../assets/media_logos/szeretlekmo.jpg" alt="szeretlek magyarország logo" height="95px"></a>
        <a href="https://bit.ly/3bVoljE" target="_blank"><img src="../assets/media_logos/bors.png" alt="bors online logo" height="120px"></a>
        <a href="https://bit.ly/2WVy6dd" target="_blank"><img src="../assets/media_logos/tv2.png" alt="tv2 logo" height="60px" class="extra-width"></a>
        <div class="break"></div>
        <a href="https://bit.ly/36mbR3l" target="_blank"><img src="../assets/media_logos/hyp-r.jpg" alt="hyper logo" height="60px" class="extra-width"></a>
        <a href="https://bit.ly/2LU5VoA" target="_blank"><img src="../assets/media_logos/m2_petofi.png" alt="mr2 petőfi logo" height="75px" class="extra-width"></a>
        <a href="https://bit.ly/2A26Ws6" target="_blank"><img src="../assets/media_logos/index.png" alt="index.hu logo" height="55px"></a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MediaSection"
}
</script>

<style scoped>
.media-section-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  height: 250px;
  padding-top: 20px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 10vw;
  width: 100%;
  max-width: 1400px;
}

.text {
  width: 100%;
  text-align: left;
  font-weight: bold;
  font-size: 22px;
  padding-left: 10px;
}

.icon-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.extra-width {
  margin: 0 20px;
}

.break {
  display: none;
  flex-basis: 100%;
  height: 0;
}

@media only screen and (max-width: 1200px) {
  .break {
    display: block;
  }

  .icon-wrapper {
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .text {
    padding-left: 10px;
  }

  .media-section-container {
    height: 300px;
  }
}

@media only screen and (max-width: 700px) {
  .media-section-container {
    display: none;
  }
}

</style>
